// import axios from "axios";

export default {
  state: () => ({
    show: false,
    step: 1,
  }),
  mutations: {
    setShow(state, data) {
      state.show = data;
    },
    setStep(state, data) {
      state.step = data;
    },
  },
  actions: {
    toggleShow({ state, commit }) {
      commit("setShow", !state.show);
    },
    handleStep({ commit }, step) {
      commit("setStep", step);
    },
  },
  namespaced: true,
};
